import { PaginatedDataDTO, PaginationDTO } from '@bottega52/commons-pagination';
import { WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { Share } from "@material-ui/icons";
import _ from 'lodash';
import * as React from "react";
import { DataGrid, GridColumns } from '@mui/x-data-grid';
import { Stack } from '@mui/system';
import moment from 'moment';
import ReduxLanguage from '../ReduxLanguage';
import translations from '../../translations/i18next';
import { IGatewayDeploymentStatusInDTO } from '../../repository/jago/model/input/IGatewayDeploymentStatusInDTO';
import { getGatewayDeploymentStatusColor } from '../../utils/Utils';

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});

export interface IGatewayDeploymentsTableProps extends WithStyles<typeof styles>{
  deployments: PaginatedDataDTO<IGatewayDeploymentStatusInDTO>;
  onFetchMoreItems: (page: number) => void;
  isLoading?: boolean;
  rowsPerPage?: number;
  onPageSizeChange?: (pageSize: number) => void;
}

export interface IGatewayDeploymentsTableState {
  tableColumns: GridColumns<IGatewayDeploymentStatusInDTO>;
}


class GatewayDeploymentsTable extends React.Component<IGatewayDeploymentsTableProps, IGatewayDeploymentsTableState> {
  constructor(props: IGatewayDeploymentsTableProps) {
    super(props);
    this.state = {
      tableColumns: [
        {
          field: 'id',
          headerName: 'Id',
          type: 'string',
          sortable: true,
          filterable: true,
          width: 100,
        },
        {
          field: 'artifact',
          headerName: translations.t('gateways.gatewaysArtifact'),
          type: 'string',
          width: 250,
          sortable: true,
          filterable: true,
          resizable: true,
          renderCell: (params) => {
            const deployment = params.row;
            return (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span style={{ fontWeight: 'bold' }}>{deployment?.artifact?.name}</span>
              </div>
            );
          }
        },
        {
          field: 'scheduledAt',
          headerName: translations.t('gateways.deploymentScheduledAt'),
          type: 'string',
          width: 200,
          sortable: true,
          filterable: true,
          renderCell: (params) => {
            const deployment = params.row;
            return (
              <div>
                {deployment?.scheduledAt ? moment(deployment.scheduledAt).format('LLL') : '-'}
              </div>
            );
          }
        },
        {
          field: 'createdByEmail',
          headerName: translations.t('gateways.createdBy'),
          type: 'string',
          width: 200,
          sortable: true,
          filterable: true,
          renderCell: (params) => {
            const deployment = params.row;
            return (
              <div>
                {deployment?.createdByEmail || 'N/A'}
              </div>
            );
          }
        },
        {
          field: 'status',
          headerName: translations.t('forms.status'),
          type: 'string',
          width: 200,
          sortable: true,
          filterable: true,
          renderCell: (params) => {
            const deployment = params.row;
            return (
              <div>
                {deployment?.status ? (
                  <div style={{ backgroundColor: getGatewayDeploymentStatusColor(deployment?.status), padding: 10, borderRadius: 5 }} >
                    <h5 style={{ color: 'white', fontWeight: 'bold', margin: 0 }}><ReduxLanguage languageKey={`gateways.${deployment?.status}`} /></h5>
                  </div>
                ) : <h5 style={{ color: 'white', fontWeight: 'bold', margin: 0 }}>N/A</h5>}
              </div>
            );
          }
        }
      ]
    };
  }

  public render() {
    const { deployments, onFetchMoreItems } = this.props;
    const { tableColumns } = this.state;
    
    const deploymentsPagination = !_.isEmpty(deployments) && (deployments.pagination) ? (deployments.pagination as PaginationDTO) : null;
    const currentPage = deploymentsPagination ? deploymentsPagination.number : 0;
    return (
      <div style={{ margin: 10, height: '100%' }}>
        <DataGrid
          getRowId={(d) => d.id}
          rows={deployments?.content || []}
          columns={tableColumns}
          rowHeight={50}
          disableSelectionOnClick
          onPageChange={page => onFetchMoreItems(page)}
          page={currentPage}
          rowCount={deploymentsPagination?.totalElements || 0}
          pageSize={20}
          paginationMode="server"
          componentsProps={{
            pagination: {
              labelRowsPerPage: translations.t('forms.rowsPerPage')
            }
          }}
          components={{
            NoRowsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                  <Share style={{ alignSelf: 'center', fontSize: 40 }} />
                  <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}>
                    <ReduxLanguage languageKey='gateways.noDeploymentFoundTitle' />
                  </h3>
                  <h4 style={{ textAlign: 'center', marginTop: 0 }}>
                    <ReduxLanguage languageKey='gateways.noDeploymentFoundDescription' />
                  </h4>
                </div>
              </Stack>
            ),
            NoResultsOverlay: () => (
              <Stack height="100%" alignItems="center" justifyContent="center">
                <h3 style={{ textAlign: 'center', fontWeight: 'bold', marginBottom: 0 }}>
                  <ReduxLanguage languageKey='gateways.noDeploymentFoundTitle' />
                </h3>
                <h4 style={{ textAlign: 'center', marginTop: 0 }}>
                  <ReduxLanguage languageKey='gateways.noDeploymentFoundDescription' />
                </h4>
              </Stack>
            )
          }}
          sx={{
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',
            },
          }}
        />
      </div>
    );
  }
}

export default withStyles(styles)(GatewayDeploymentsTable);